<template>
    <strong><label :style="{ 'font-size': fontSize }">{{ labelText }}</label></strong>
    <label :style="{ 'font-size': fontSize, 'padding-left': '10px' }">{{ fileLimitText }}</label>
    <div class="row d-flex" style="flex-wrap: nowrap;">
        <div class="input-group mb-3 mt-2 col-6" style="width: 420px;">
            <label class="input-file-size" :for="id">
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#9F3029"
                    class="bi bi-file-earmark-arrow-up svg-style" :style="customSvgStyle" viewBox="0 0 16 16">
                    <path
                        d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707V11.5z" />
                    <path
                        d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                </svg>
                <h5 v-if="hasFile == true" class="anexo-title">- {{ file.name }}</h5>
                <h5 v-if="file == null && uploadSucesso == false" class="text-muted" :style="customTextMuted">- Clique aqui
                    para
                    selecionar o arquivo
                </h5>
            </label>
            <input type="file" :name="id" :id="id" class="form-control shadow-v2" :disabled="disable"
                :class="{ filled: file }" @change="uploadVideo" :required="isRequired" :accept="whoFiles">
            <Field :name="id" label="Arquivo" type="hidden" v-model="file" />
            <ErrorMessage :name="id" class="form-error" />

        </div>
        <div class="text-center col-6 pt-1" v-if="loading_upload">
            <div class="spinner-border text-danger dinamicWid" style="width: 3rem; height: 3rem;" role="status">
            </div>
            <p class="text-break mb-0 dinamicWidText">Aguarde o upload do vídeo terminar...</p>
        </div>
    </div>
    <div v-if="uploadSucesso == true" style="min-width: 50%;max-height: 35px;">
        <div class="wait-file pt-1">
            <span title="Vizualizar Arquivo"><i class="fas fa-file-alt icon-size ml-10"></i>
                {{ file.name }}</span>
            <button type="button" class="btn-grid-excluir-lista" @click="excluirAnexo()" style="float: right">
                <i class="fa fa-trash" aria-hidden="true"></i><span class="btn-span-text">Excluir</span>
            </button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import AWS from 'aws-sdk';


    export default {
        emits: ['onSave'],
        props: {
            labelText: {
                type: String,
                required: true,
                default: 'Upload Vídeo',
            },
            fontSize: {
                type: String,
                default: '14px',
            },
            fileLimitText: {
                type: String,
                default: 'Limite de arquivos até 800MB.',
            },
            // multiple: {
            //     type: Boolean,
            //     default: false,
            // },
            // urlUpload: {
            //     type: String,
            //     required: true,
            // },
            // manualDisable: {
            //     type: Boolean,
            //     default: false
            // },
            customTextMuted: {
                type: String,
                default: ''
            },
            customSvgStyle: {
                type: String,
                default: ''
            },
            // hasListaUpload: {
            //     type: String,
            //     default: ''
            // },
            // hasVizualizar: {
            //     type: Boolean,
            //     default: false
            // },
            isRequired: {
                type: Boolean,
                default: false
            },
            whoFiles: {
                type: String,
                default: 'video/*'
            },
            // maxFileSize: {
            //     type: Number,
            //     default: 800,
            // },

        },
        data() {
            return {
                file: null,
                uploadSucesso: false,
                disable: false,
                hasFile: false,
                id: 'input_file',
                fileVizualizacao: '',
                loading_upload: false
            }

        },
        mounted() {

        },
        methods: {
            newHash() {
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let hash = '';

                for (let i = 0; i < 6; i++) {
                    const randomIndex = Math.floor(Math.random() * characters.length);
                    hash += characters.charAt(randomIndex);
                }

                return hash;
            },
            async uploadVideo(event) {
                let $this = this;

                const file = event.target.files[0];
                $this.file = event.target.files[0];
                AWS.config.update({
                    accessKeyId: process.env.VUE_APP_ROOT_ACCESSKEYID,
                    secretAccessKey: process.env.VUE_APP_ROOT_SECRETACCESSKEY,
                    region: 'sa-east-1'
                });

                const s3 = new AWS.S3();
                var hash = $this.newHash() + '_';

                var key = `v2/comercial/registros/video_chamadas/${hash}${file.name}`;

                const params = {
                    Bucket: process.env.VUE_APP_ROOT_BUCKET,
                    Key: key,
                    Body: file,
                    ACL: 'public-read'
                };

                try {
                    $this.loading_upload = true;
                    const data = await s3.upload(params).promise();
                    $this.$emit('onSave', key);
                    $this.loading_upload = false;
                    $this.hasFile = true;
                    $this.uploadSucesso = true;

                } catch (error) {
                    $this.loading_upload = false;
                }
            },
            excluirAnexo() {

                this.uploadSucesso = false;
                this.file = null;

                document.getElementById(this.id).value = "";
                this.$emit('onSave', '');
                this.hasFile = false;
                // this.disable = false;
            },

            resetVariaveis() {
                this.file = null;
                this.uploadSucesso = false;
                // this.disable = false;
                this.hasFile = false;

                document.getElementById(this.id).value = null;

            },

        },
        watch: {

        },

    }
</script>

<style scoped lang="scss">
.btn-white {
    border: 1px solid #AB0000;
}

.buttonUpload {
    min-width: 24.5%
}

.ml-10 {
    margin-left: 10px !important;
}

.wait-file {
    // margin-left: 10px !important;
    // margin-top: 25px !important;
    font-size: 14px !important;
}

.input-file-size {
    border-radius: 0px;
    min-height: 80px;
    height: 80px;
    width: 100%;
    max-width: 100%;
    border: 2px dashed grey;
    cursor: pointer;

    .anexo-title {
        font-size: 16px;
        color: #AB0000;
        margin-left: 15%;
        padding-top: 27px;
        font-size: 16px;
    }

    .text-muted {
        margin-left: 15%;
        padding-top: 7%;
        font-size: 14px;

    }
}

input {
    display: none;
}

.svg-style {
    position: absolute;
    left: 22px;
    top: 15px
}

.mt-35 {
    margin-top: 35px;
}

.file-campo {
    border: 1px dashed #f4f4f4;
}

.btn-green {
    font-weight: 700;
    border-radius: 5px !important;
}

.btn-red {
    border-radius: 5px !important;
}

.line-card {
    max-width: 10px;
    margin-left: -3px;
    margin-top: -1px;
    margin-bottom: -2px;
}

.bg-color-red {
    background-color: #AB0000;
}

.bg-color-green {
    background: #34A853;
}

.icon-size {
    height: 50px;
    color: #34A853;
}

@media screen and (max-width: 1400px) {
    .input-file-size {
        .text-muted {
            margin-left: 25%;
        }

        .anexo-title {
            margin-left: 25%;
            padding-top: 1.5rem;
        }
    }

    .dinamicWid {
        left: -41px !important;
        position: relative !important;
    }

    .dinamicWidText{
        width: 220px;
    }

    .line-card {
        margin-left: 5px !important;
    }

    .buttonUpload {
        min-width: 100%;
    }
}
</style>